<script>
import { mapStores } from "pinia";

import { SKIP_INSTITUTION_SELECTOR } from "@/common/auth-types";
import { loginRequest } from "@/common/login.service";
import { useAuthStore } from "@/stores";

export default {
  name: "RedirectFromOrdbogenView",
  computed: {
    ...mapStores(useAuthStore)
  },
  async created() {
    if (this.authStore.isAuthenticated) {
      await this.$router.push({ name: "home" });
      return;
    }

    // Simulate normal login, but send them back here - user is already authenticated with Unilogin
    sessionStorage.setItem(SKIP_INSTITUTION_SELECTOR, true);
    await loginRequest("login-from-ordbogen", "/dictionary");
  }
};
</script>

<template>
  <main class="container p-0 d-flex flex-column justify-content-center align-items-center">
    <div class="row justify-content-center mx-0 w-100">
      <div class="col-12 col-lg-5 py-4 bg-white rounded">
        <h1 class="m-0 text-center">{{ $t("ordbogenRedirect.loggingIn") }}</h1>
      </div>
    </div>
  </main>
</template>
